var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "d-flex flex-column align-center mt-16",
    attrs: {
      "color": "transparent",
      "id": "director"
    }
  }, [_c('headshot-circle', {
    attrs: {
      "headshotData": {
        name: 'Matthew Wuthenow',
        title: 'Director',
        headshot: 'https://media.eipl.org/site/images/pages/about/board/matt.jpg'
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }